module.exports = __webpack_public_path__ + "static/media/student-details-icon.6397cf18.svg";